/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum OrgaFolderItemType {
    Document = 1,
    Folder = 2,
}
